export default "__VITE_ASSET__B3fBAXUm__"